type ExecutorParameters<R> = Parameters<ConstructorParameters<typeof Promise<R>>[0]>;

const promise = <R>(fn: (...args: ExecutorParameters<R>) => unknown): Promise<R> =>
  new Promise<R>((...args) => {
    fn(...args);
  });

const tryRun = async <A extends unknown[], R>(
  fn: (...args: A) => R,
  resolvers: ExecutorParameters<R>,
  fnArgs: A,
): Promise<void> => {
  try {
    resolvers[0](await fn(...fnArgs));
  } catch (e) {
    resolvers[1](e);
  }
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const runWithMicrotask = <A extends unknown[], R>(
  fn: (...args: A) => R,
  ...fnArgs: A
): Promise<Awaited<R>> =>
  promise<Awaited<R>>((...resolvers) =>
    queueMicrotask(() => tryRun(fn as never, resolvers, fnArgs)),
  );

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const runWithMacrotask = <A extends unknown[], R>(
  fn: (...args: A) => R,
  ...fnArgs: A
): Promise<Awaited<R>> =>
  promise<Awaited<R>>((...resolvers) => {
    setTimeout(() => tryRun(fn as never, resolvers, fnArgs), 0);
  });

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const runWithAnimationFrame = <A extends unknown[], R>(
  fn: (this: Parameters<FrameRequestCallback>[0], ...args: A) => R,
  ...fnArgs: A
): Promise<Awaited<R>> =>
  promise<Awaited<R>>((...resolvers) => {
    requestAnimationFrame((time) => tryRun(fn.bind(time) as never, resolvers, fnArgs));
  });

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const runWithRenderSlice = <A extends unknown[], R>(
  fn: (this: Parameters<FrameRequestCallback>[0], ...args: A) => R,
  ...fnArgs: A
): Promise<Awaited<R>> =>
  promise<Awaited<R>>((...resolvers) => {
    requestAnimationFrame((time) => {
      setTimeout(() => tryRun(fn.bind(time) as never, resolvers, fnArgs), 0);
    });
  });
